import { IconButton } from '@mui/material';
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSync } from '@fortawesome/free-solid-svg-icons';
import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';

const rotate = keyframes({
    from: {
        transform: 'rotate(0deg)'
    },
    to: {
        transform: 'rotate(360deg)'
    }
});

const Frame = styled.div<{ rotating: boolean }>(props => ({
    animation: props.rotating ? `${rotate} 1s linear infinite` : undefined,
}));

export type SyncButtonProps = {
    syncing: boolean;
    hidden?: boolean;
    disabled?: boolean;
    onClick?: () => void;
}

export function SyncButton(props: SyncButtonProps) {
    const { syncing, hidden = false, disabled = false, onClick } = props;

    return <IconButton hidden={hidden} disabled={disabled} size='small' onClick={onClick}>
        <Frame hidden={hidden} rotating={syncing}>
            <FontAwesomeIcon icon={faSync} />
        </Frame>
    </IconButton>;
}
